/**
 * @desc 海关要素-新增（未报关）
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PurchaseCustomsInfoRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/purchasingCustomsElementsSave`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
